let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iGK8U")).then(() => parcelRequire('jlvUH'));